// PURE DATA + loader arrows. No lazy(), no side effects (see ../types.ts contract).
import type { ModuleManifest } from '../types';

export const paymentsModule: ModuleManifest = {
  id: 'payments',
  routes: [
    { path: '/invoice/:token', load: () => import('./pages/InvoicePage') },
  ],
  // no menuItems — invoice pages are reached via emailed capability links only
  // Guarded by the ADMIN define so panel chunks aren't emitted in admin-less builds
  adminPanel: __MODULE_ADMIN__
    ? [
        { title: 'Payments', icon: 'payments', path: 'payments', load: () => import('./admin/PaymentsPanel') },
        { title: 'Invoices', icon: 'invoices', path: 'invoices', load: () => import('./admin/InvoicesPanel') },
        { title: 'Products & Services', icon: 'products', path: 'products', load: () => import('./admin/ProductsPanel') },
      ]
    : undefined,
};
